import { useBodyClass } from "../../hooks"

export function usePageTypeBodyClass(page, fromStartPage) {
  const { pageType } = page
  const className = fromStartPage ? null : `page-type-${pageType}`
  useBodyClass(className)
  return pageType
}
